import axios from 'axios'

export default axios.create({
    baseURL: 'http://47.108.214.106:8080',
    // baseURL: 'http://127.0.0.1:8080',
    timeout: 15000
})



// WEBPACK FOOTER //
// ./src/api/index.js